/*********************
 Cart Open/Close
 *********************/

// Set a bundle progress item width
function setBundleFooterProgressWidth(element, width) {
    element.children[0].style = `width: ${width}`;
}

// function to open the cart
async function openCart(skipStatusAnimation = false) {
    // close nav and search
    closeNav();
    closeSearch();

    // open cart
    document.querySelector("#cart").classList.add("open");
    document.querySelector("body").classList.add("overlay");

    // start loading
    document.querySelector("#cartContent").classList.add("loading");

    // get cart info
    cart = await fetch("/cart?view=json-feed")
        .then(data => data.json());

    // create updates
    let updates = {};
    cart.items.forEach((item) => {
        // check for free product
        if (item.properties && item.properties._gift === "true") {
            updates[item.key] = 0;
        }

        // if we're not allowing out of stock purchases, check if the item is ordering more than the inventory
        if (settings.allow_out_of_stock === false && item.quantity > item.inventory) {
            updates[item.key] = item.inventory;
        }
    })

    // update cart if there are any updates
    if (Object.keys(updates).length > 0) {
        // start loading
        document.querySelector("#cartContent").classList.add("loading");

        // update cart
        cart = await updateCart({
            updates: updates
        });

        // open cart
        await openCart();

        return;
    }

    // reset state, everything is hidden and dynamic content is removed
    document.querySelector("#cartCountdown")?.classList.remove("active");
    document.querySelector("#cartStatusV1").classList.remove("active");
    document.querySelector("#cartStatusV2").classList.remove("active");
    document.querySelectorAll("#cartContent > *:not(#cartFreeProduct)").forEach(element => element.remove());
    document.querySelector("#cartFreeProduct").classList.remove("active");
    document.querySelector("#cartEmpty").classList.remove("active");
    document.querySelector("#cartFooter").classList.remove("active");

    // stop loading
    document.querySelector("#cartContent").classList.remove("loading");

    // global discount
    if (globalDiscount != 1) {
        cart.items.forEach(function (item) {
            // discounts don't apply ot gift cards
            if (item.gift_card == false) {
                //apply discounts
                item.compare_at_price_real = item.compare_at_price;
                if (item.compare_at_price == null) {
                    item.compare_at_price = item.price;
                }
                item.price *= globalDiscount;
            }
        });
    }

    // update total items in cart in all places needed
    document.querySelectorAll(".totalCountCircle").forEach(function (element) {
        // update text content
        element.textContent = cart.item_count;

        // if there are no items in the cart, hide the circle
        if (cart.item_count === 0) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // update announcemnt bar (check if element exists since it doesn't during the sale)
    if (document.querySelector("#announcementRotating") && document.querySelector("#announcementUnlocked")) {
        if (cart.total_price < cartSettings.free_shipping_threshold) {
            document.querySelector("#announcementRotating").classList.add("active");
            document.querySelector("#announcementUnlocked").classList.remove("active");
        } else {
            document.querySelector("#announcementRotating").classList.remove("active");
            document.querySelector("#announcementUnlocked").classList.add("active");
        }
    }

    // check if any items are in cart
    if (cart.item_count === 0) {
        //remove local storage of gift and uncheck
        localStorage.removeItem('gift');

        // show empty cart
        document.querySelector("#cartEmpty").classList.add("active");
        return;
    }

    // show countdown banner if applicable
    document.querySelector("#cartCountdown")?.classList.add("active");

    // determine which version of the status bar to show (default to V1)
    let statusBarVersion = false;
    if (cartSettings.cart_free_product) {
        statusBarVersion = "V2";
    } else if (cartSettings.cart_free_shipping_enabled) {
        statusBarVersion = "V1";
    }

    // update V1 status bar
    if (statusBarVersion === "V1") {
        // show container
        document.querySelector("#cartStatusV1").classList.add("active");

        // if they're not at the free shipping threshold, show the progress bar
        if (cart.total_price < cartSettings.free_shipping_threshold) {
            // updat progress bar
            document.querySelector("#cartStatusV1").setAttribute("data-status", "progress");
            document.querySelector("#cartStatusV1Title").innerHTML = `YOU'RE <span>${price(cartSettings.free_shipping_threshold - cart.total_price)}</span> AWAY FROM EXPRESS SHIPPING ON US!`;
            document.querySelector("#cartStatusV1ProgressBarInner").style.width = `${cart.total_price / cartSettings.free_shipping_threshold * 100}%`;
        } else {
            // if they're not at the free product threshold, show the animation
            document.querySelector("#cartStatusV1").setAttribute("data-status", "complete");
            document.querySelector("#cartStatusV1Title").textContent = `🎉 CONGRATS! 2-DAY EXPRESS SHIPPING ON US!`;
            document.querySelector("#cartStatusV1ProgressBarInner").style.width = "100%";

            // setup confetti
            if (skipStatusAnimation === false) {
                const canvas = document.querySelector("#cartStatusV1Canvas");
                canvas.confetti = canvas.confetti || (await confetti.create(canvas, {resize: true}));
                canvas.confetti({
                    particleCount: 100,
                    spread: 70,
                    origin: {y: 0.6},
                });
            }
        }
    }

    // update V2 status bar
    if (statusBarVersion === "V2") {
        // get free shipping element
        const freeShippingElement = document.querySelector("#cartStatusV2FreeShipping");
        const freeProductElement = document.querySelector("#cartStatusV2FreeProduct");

        // create array of thresholds
        let thresholds = [
            {
                id: "cartStatusV2FreeShipping",
                threshold: cartSettings.free_shipping_threshold,
                label: freeShippingElement.getAttribute('label'),
            },
            {
                id: "cartStatusV2FreeProduct",
                threshold: cartSettings.free_product_threshold,
                label: freeProductElement.getAttribute('label'),
            }
        ];

        // 1) Sort thresholds so we know which is smaller (t1) and which is larger (t2).
        thresholds.sort((a, b) => a.threshold - b.threshold);

        // calculate the total price with OUT gift cards
        let totalPriceWithoutGiftCards = 0;
        for (const item of cart.items) {
            if (item.gift_card == false) {
                totalPriceWithoutGiftCards += item.price * item.quantity;
            }
        }

        // show container
        document.querySelector("#cartStatusV2").classList.add("active");

        // loop through thresholds to update title to closest
        for (const threshold of thresholds) {
            if (totalPriceWithoutGiftCards < threshold.threshold) {
                document.querySelector("#cartStatusV2Title").innerHTML = `
                    You are 
                    <b>${price(threshold.threshold - totalPriceWithoutGiftCards)}</b>
                    away from 
                    <b>${threshold.label}!</b>
                `;
                break;
            }
        }

        // loop through thresholds to update classes
        for (const threshold of thresholds) {
            if (totalPriceWithoutGiftCards < threshold.threshold) {
                document.querySelector(`#${threshold.id}`).setAttribute("data-status", "progress");
            } else {
                document.querySelector(`#${threshold.id}`).setAttribute("data-status", "complete");
            }
        }

        // update progress bar
        const t1 = thresholds[0].threshold; // smaller threshold
        const t2 = thresholds[1].threshold; // larger threshold
        const t2Width = document.querySelector("#" + thresholds[1].id).offsetWidth;
        const barWidth = document.querySelector("#cartStatusV2BarProgress").offsetWidth - t2Width;

        // calculate t1 offset to make sure it's proportional to the max price, however, if the thresholds are the same, hide free product and keep free shipping at the end
        if (t1 === t2) {
            document.querySelector("#cartStatusV2").classList.add("thresholds-equal");
            // don't set marginLeft - let the free shipping indicator stay at the end of the bar
        } else {
            document.querySelector("#cartStatusV2").classList.remove("thresholds-equal");
            document.querySelector("#" + thresholds[0].id).style.marginLeft = `${t1 / t2 * barWidth}px`;
        }

        // check if both have been unlocked
        if (totalPriceWithoutGiftCards >= cartSettings.free_shipping_threshold && totalPriceWithoutGiftCards >= cartSettings.free_product_threshold) {
            document.querySelector("#cartStatusV2Title").innerHTML = `🎉 Congrats! Enjoy Free shipping and your free gift!`;
            document.querySelector("#cartStatusV2BarProgressInner").style.width = "100%";
        } else {
            // calculate the width of the progress bar
            let width = totalPriceWithoutGiftCards / t2 * barWidth;

            // calculate the width of the progress bar
            document.querySelector("#cartStatusV2BarProgressInner").style.width = `${width}px`;
        }

        // check for free product
        if (totalPriceWithoutGiftCards >= cartSettings.free_product_threshold) {
            document.querySelector("#cartFreeProduct").classList.add("active");
        }

        // setup confetti
        if (skipStatusAnimation === false) {
            if (totalPriceWithoutGiftCards >= cartSettings.free_product_threshold || totalPriceWithoutGiftCards >= cartSettings.free_shipping_threshold) {
                const canvas = document.querySelector("#cartStatusV2Canvas");
                canvas.confetti = canvas.confetti || (await confetti.create(canvas, {resize: true}));
                canvas.confetti({
                    particleCount: 100,
                    spread: 70,
                    origin: {y: 0.6},
                });
            }
        }
    }

    // check if terms are enabled
    if (cartSettings.enable_terms === true) {
        document.querySelector("#cartTerms").classList.add("active");
    } else {
        document.querySelector("#cartTerms").classList.remove("active");
    }

    // append each cart item and setup event listeners
    cart.items.forEach(function (item) {
        function cartItemDiscountBadge() {
            // discount badge for on sale items
            if (item.compare_at_price != null) {
                return `<div class="cartItemDiscountBadge">${price(item.quantity * (item.compare_at_price - item.price))} Off</div>`;
            }

            return "";
        }

        function cartItemVariants() {
            //check if there are any variants
            if (item.variant_title != null && item.variant_title != "Default Title") {
                return `<div class="cartItemVariants">${item.variant_title}</div>`;
            } else {
                return "";
            }
        }

        function cartItemPersonalize() {
            //check if it's personalize
            // short-circut due to gift card not having properties
            if (item.properties && item.properties.Personalize) {
                return `<div class="cartItemPersonalize">Personalize: ${item.properties.Personalize}</div>`;
            } else {
                return "";
            }
        }

        function cartItemProperties() {
            // properties, but not personalize
            if (item.properties && !item.properties.Personalize) {
                // generate HTML for each item
                let HTML = `<div class="cartItemPersonalize">`;
                for (const key in item.properties) {
                    // skip if starts with a _
                    if (key.startsWith("_")) {
                        continue;
                    }

                    // Ignore date - use inside the cartItemStock function
                    if (key !== "Send on") {
                        // check for link
                        if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                            HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                            continue;
                        }
                        // catch all
                        HTML += `${key}: ${item.properties[key]}<br>`;
                    }
                }
                HTML += `</div>`;
                // return string
                return HTML;
            } else {
                return "";
            }
        }

        function cartItemStock(item) {
            // if gift card
            if (item.gift_card) {
                // check for send on date
                if (item.properties["Send on"]) {
                    // check for current date
                    const now = new Date();
                    const itemDate = new Date(item.properties["Send on"]);
                    const formattedDate = `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
                    if (itemDate < now) {
                        item.properties["Send on"] = formattedDate;
                    }
                    if (formattedDate === item.properties["Send on"]) {
                        return `
                            <div class="cartItemStockReady">
                                <span class="cartItemStockReadyIcon"></span>
                                <span class="cartItemStockReadyLabel">Instant Delivery</span> 
                            </div>
                        `;
                    } else {
                        return `
                            <div class="cartItemStockReady">
                                <span class="cartItemStockReadyIcon"></span> 
                                <span class="cartItemStockReadyLabel">Delivery ${item.properties["Send on"]}</span> 
                            </div>
                        `;
                    }
                }

                // return default
                return `
                    <div class="cartItemStockReady">
                        <span class="cartItemStockReadyIcon"></span>
                        <span class="cartItemStockReadyLabel">Instant Delivery</span> 
                    </div>
                `;
            }
            //if the item the customer is ordering is less than the quantity in stock AND the product is not personalized
            else if (item.quantity <= item.inventory && item.properties.Personalize == undefined) {
                return `
                    <div class="cartItemStockReady">
                        <span class="cartItemStockReadyIcon"></span> 
                        <span class="cartItemStockReadyLabel">In stock</span>
                    </div>
                `;
            }
            // if there is at least one in stock, show in stock break down
            else if (item.inventory >= 1) {
                return `
                    <div class="cartItemStockReady">
                        <span class="cartItemStockReadyIcon"></span> 
                        <span class="cartItemStockReadyLabel">${item.quantity - (item.quantity - item.inventory)} - In stock</span>
                    </div>
                    <div class="cartItemStockMTO">
                        <span class="cartItemStockMTOIcon"></span> 
                        <span class="cartItemStockMTO">${item.quantity - item.inventory} - Made to order: ${settings.mto}</span>
                    </div>
                `;
            } else {
                return `
                    <div class="cartItemStockMTO">
                        <span class="cartItemStockMTOIcon"></span> 
                        <span class="cartItemStockMTO">Made to order: ${settings.mto}</span>
                    </div>
                `;
            }
        }

        function cartItemComparePrice() {
            if (item.compare_at_price != null && item.compare_at_price > item.price) {
                return `<div class="cartItemComparePrice">${price(item.compare_at_price * item.quantity)}</div>`;
            }
            return "";
        }

        document.querySelector("#cartContent").insertAdjacentHTML("beforeend", `
            <div class="cartItem" id="lineItem${item.key}">
                <div class="cartItemContainer">
                    <a class="cartItemImage" href="${item.url}" style="background-image: url(${item.image})"></a>
                    ${cartItemDiscountBadge()}
                </div>
                <div class="cartItemContent">
                    <a class="cartItemTitle" href="${item.url}">${item.product_title}</a>
                    ${cartItemVariants()}
                    ${cartItemPersonalize()}
                     ${cartItemProperties()}
                    <div class="cartItemStock">${cartItemStock(item)}</div>
                    <div class="cartItemEditor">
                        <div class="cartItemIncrementer">
                            <div class="cartItemMinus"><i class="fal fa-minus fa-xs"></i></div>
                            <div class="cartItemCount" unitprice="${Math.round(item.price / 100)}">${item.quantity}</div>
                            <div class="cartItemPlus"><i class="fal fa-plus fa-xs"></i></div>
                        </div>
                        <div class="cartItemRemove">
                       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.196" viewBox="0 0 24 23.196">
                            <g>
                                <g>
                                    <rect y="3.397" width="24" height="2" fill="#807c7c" stroke-width="0"/>
                                    <path d="M15.863,23.196h-7.726c-2.054,0-3.764-1.54-3.978-3.583l-1.586-15.111,1.989-.209,1.586,15.111c.107,1.021.962,1.792,1.989,1.792h7.726c1.027,0,1.882-.771,1.989-1.792l1.586-15.111,1.989.209-1.586,15.111c-.214,2.043-1.924,3.583-3.978,3.583Z" fill="#807c7c" stroke-width="0"/>
                                    <rect x="8.924" y="10.942" width="6.152" height="2" transform="translate(-1.312 1.482) rotate(-6.702)" fill="#807c7c" stroke-width="0"/>
                                    <rect x="11" y="13.596" width="2" height="6.152" transform="translate(-5.956 26.648) rotate(-83.309)" fill="#807c7c" stroke-width="0"/>
                                    <polygon points="18.213 4.938 16.329 2 7.385 2 5.792 4.539 4.098 3.477 6.278 0 17.422 0 19.897 3.857 18.213 4.938" fill="#807c7c" stroke-width="0"/>
                                </g>
                            </g>
                        </svg>
                        </div>
                    </div>
                </div>
                <div class="cartItemPriceInfo">
                    <div class="cartItemPrice ${item.compare_at_price && item.compare_at_price > item.price ? "sale" : ""}">${price(item.price * item.quantity)}</div>
                    ${cartItemComparePrice()}
                </div>
            </div>
        `);

        // save line element
        const lineElement = document.querySelector(`[id="lineItem${item.key}"]`);

        // create event listeners - MINUS
        lineElement.querySelector(`.cartItemMinus`).addEventListener("click", async function () {
            // start loading
            document.querySelector("#cartContent").classList.add("loading");

            // update product
            await changeProduct({
                quantity: item.quantity - 1,
                id: item.key
            });

            // open cart and skip free shipping animation
            await openCart(true);
        });

        // create event listeners - PLUS
        lineElement.querySelector(`.cartItemPlus`).addEventListener("click", async function () {
            // if we're blocking out of stock items, check if the item is already at max inventory
            if (settings.allow_out_of_stock === false && item.inventory == item.quantity) {
                alert(settings.block_made_to_order_message);
                return;
            }

            // start loading
            document.querySelector("#cartContent").classList.add("loading");

            // old total
            const oldTotal = cart.total_price;

            // update product
            cart = await updateCart({
                updates: {
                    [item.key]: item.quantity + 1
                }
            });

            // new total
            const newTotal = cart.total_price;

            // check if we didn't cross a new threshold, if so, skip animation. Note, thresholds can be swapped
            let skipStatusAnimation = true;
            if (cartSettings.cart_free_product && oldTotal < cartSettings.free_product_threshold && newTotal >= cartSettings.free_product_threshold) {
                skipStatusAnimation = false;
            } else if (oldTotal < cartSettings.free_shipping_threshold && newTotal >= cartSettings.free_shipping_threshold) {
                skipStatusAnimation = false;
            }

            // open cart
            await openCart(skipStatusAnimation);
        });

        // create event listeners - REMOVE
        lineElement.querySelector(`.cartItemRemove`).addEventListener("click", async function () {
            // start loading
            document.querySelector("#cartContent").classList.add("loading");

            // update product
            await changeProduct({
                quantity: 0,
                id: item.key
            });

            // open cart
            await openCart(true);
        });

    });

    // enable footer
    document.querySelector("#cartFooter").classList.add("active");

    // add gift
    document.querySelector("#cartContent").insertAdjacentHTML("beforeend", `
         <button id="cartGift" class="cartGiftOpen">
            <div id="cartGiftBox">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" ><path d="M20 6 9 17l-5-5"/></svg>
            </div>
            <div id="cartGiftText">Add a gift message</div>
            <div id="cartGiftIcon">
                <svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.91 24">
                  <rect x="1.84" y="7.5" width="19.23" height="4.18" style="fill: none;"/>
                  <path d="M5.85,2.07c-.34.82-.79,2.33-.2,3.59h7.78c-1.6-1.23-4.18-2.81-7.59-3.59Z" style="fill: none;"/>
                  <path d="M17.25,5.66c.59-1.25.15-2.76-.19-3.58-1.43.39-2.52,1.05-3.24,1.59,1.16.81,1.98,1.55,2.42,1.99h1.01Z" style="fill: none;"/>
                  <path d="M3.28,20.32c0,1.01.82,1.84,1.84,1.84h12.66c1.01,0,1.84-.82,1.84-1.84v-6.8H3.28v6.8Z" style="fill: none;"/>
                  <path d="M22.91,5.66h-3.7c.66-2.46-.77-4.98-.84-5.1l-.33-.56-.64.12c-2.53.48-4.3,1.74-5.21,2.52C10.43,1.62,8.19.64,5.51.12L4.87,0l-.33.56c-.07.13-1.5,2.64-.84,5.1H0v7.86h1.45v6.8c0,2.03,1.65,3.68,3.68,3.68h12.66c2.03,0,3.68-1.65,3.68-3.68v-6.8h1.45v-7.86ZM17.06,2.08c.34.82.78,2.33.19,3.58h-1.01c-.45-.44-1.26-1.17-2.42-1.99.71-.54,1.81-1.2,3.24-1.59ZM5.85,2.07c3.41.78,5.99,2.36,7.59,3.59h-7.78c-.59-1.26-.14-2.78.2-3.59ZM1.84,7.5h19.23v4.18H1.84v-4.18ZM19.62,20.32c0,1.01-.82,1.84-1.84,1.84H5.12c-1.01,0-1.84-.82-1.84-1.84v-6.8h16.34v6.8Z" style="fill: #807c7c;"/>
                </svg>
            </div>
        </button>
    `);

    // add gift event listeners
    updateGift();

    // add subtotal
    document.querySelector("#cartContent").insertAdjacentHTML("beforeend", `<div id="cartSubtotal">Subtotal ${price(cart.total_price)}</div>`);


    // check if gift message should be shown
    // if there are any products that are not gift cards then we need to allow the customer to add a message
    let hasGiftCards = cart.items.filter(item => item.gift_card != false).length == 0;
    if (hasGiftCards && cartSettings.enable_gifting === true) {
        document.querySelector("#cartGift").classList.add("active");
    } else {
        document.querySelector("#cartGift").classList.remove("active");
    }

    //global discount
    if (globalDiscount != 1) {
        //document.querySelector("#cartContent").insertAdjacentHTML("beforeend", `<div id="cartSavings">Cyber Monday Total Savings: ${price(cart.total_discount)}</div>`);
        document.querySelector("#cartContent").insertAdjacentHTML("beforeend", `<div id="cartSavings">Final Sale. No Refunds. No Exchanges.</div>`);
    }

    //check is upsell is needed
    let addUpsell = true;
    for (let i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key.includes(upsell.variants[0].id)) {
            addUpsell = false;
            break;
        }
    }

    if (addUpsell) {
        //add upsell
        document.querySelector("#cartContent").insertAdjacentHTML("beforeend", `
            <div id="cartUpsell">
                <a id="cartUpsellLink" href="/products/${upsell.handle}">
                    <img id="cartUpsellImage" src="${upsell.featured_image}?width=300">
                </a>
                <div id="cartUpsellInfo">
                    <a id="cartUpsellTitle" href="/products/${upsell.handle}">${upsell.title}</a>
                    <div id="cartUpsellButton" class="button alt"></div>
                </div>
            </div>
        `);

        // add price
        if (globalDiscount == 1) {
            document.querySelector("#cartUpsellButton").textContent = `Add | ${price(upsell.price)}`;
        } else {
            document.querySelector("#cartUpsellButton").innerHTML = `Add | <span class="sale">${price(upsell.price * globalDiscount)}</span> <s>${price(upsell.price)}</s>`;
        }

        //upsell click
        document.querySelector("#cartUpsellButton").addEventListener("click", async function () {
            // start loading
            this.classList.add("loading");

            // start loading
            document.querySelector("#cartContent").classList.add("loading");

            // add product
            await addProduct({
                quantity: 1,
                id: upsell.variants[0].id,
            });

            // reset cart
            await openCart();
        });
    }

}

// close cart function
function closeCart() {
    // close cart
    document.querySelector("#cart").classList.remove("open");
    document.querySelector("body").classList.remove("overlay");

    // close gift modal
    document.querySelector("#giftModal").classList.remove("active");
}

// open cart event
document.querySelectorAll(".navCart").forEach(function (element) {
    element.addEventListener("click", async function () {
        // open cart
        await openCart();
    });
});

// close cart event
document.querySelector("#cartHeaderExit").addEventListener("click", closeCart);

/********************
 Countdown
 *******************/

if (document.querySelector("#cartCountdown")) {
    // countdown is 10 minutes from first page load (use session storage)
    const cartCountdownDuration = cartSettings.countdown_duration;
    let cartCountdownDate = new Date().getTime() + cartCountdownDuration * 1000;

    // check if countdown is in local storage
    if (sessionStorage.cartCountdown) {
        cartCountdownDate = parseInt(sessionStorage.cartCountdown);
    }

    // update countdown in local storage
    sessionStorage.cartCountdown = cartCountdownDate;

    // update countdown every second
    const cartCountdownInterval = setInterval(function () {
        // get current time
        let now = new Date().getTime();

        // calculate difference
        let difference = cartCountdownDate - now;

        // if countdown is over us complete message and clear interval
        if (difference < 0) {
            document.querySelector("#cartCountdown").innerText = cartSettings.countdown_expired_message;
            clearInterval(cartCountdownInterval);
            return;
        }

        // calculate remaining time
        let minutesLeft = Math.floor((difference % (hour)) / (minute));
        let secondsLeft = Math.floor((difference % (minute)) / second);

        // if less than 10 seconds, add a 0
        if (secondsLeft < 10) {
            secondsLeft = `0${secondsLeft}`;
        }

        // update countdown
        document.querySelector("#cartCountdown").innerHTML = cartSettings.countdown_active_message.replace("|COUNTDOWN|", `${minutesLeft}:${secondsLeft}`);
    }, 1000);
}

/*********************
 Gift Modal
 *********************/

function updateGift() {

    //update gift modal
    if (localStorage.gift) {
        document.querySelector("#cartGiftText").textContent = "Edit";
        document.querySelector("#cartGiftBox").classList.add("active");

        document.querySelector("#giftMessage").value = localStorage.gift;
        //gift message animation
        if (document.querySelector("#giftMessage").value.length > 0) {
            document.querySelector("#giftMessageLabel").classList.add("active");
        }
        document.querySelector("#giftMessageCount").textContent = 250 - parseInt(document.querySelector("#giftMessage").value.length);
    }

    // open gift modal
    document.querySelector(".cartGiftOpen").addEventListener("click", function () {
        document.querySelector("#giftModal").open();
    });

    //gift character count keyup
    document.querySelector("#giftMessage").addEventListener("keyup", function () {
        //gift message animation
        if (document.querySelector("#giftMessage").value.length > 0) {
            document.querySelector("#giftMessageLabel").classList.add("active");
        } else {
            document.querySelector("#giftMessageLabel").classList.remove("active");
        }
        document.querySelector("#giftMessageCount").textContent = 250 - parseInt(document.querySelector("#giftMessage").value.length);
    });

    //gift message prevent emojis
    // https://stackoverflow.com/a/56050435
    document.querySelector("#giftMessage").addEventListener("input", event => {
        document.querySelector("#giftMessage").value = document.querySelector("#giftMessage").value.replace(/[^a-zA-Z0-9.,!?& ]/gm, '');
    }, false);

    document.querySelector("#giftMessage").addEventListener("paste", event => {
        document.querySelector("#giftMessage").value = document.querySelector("#giftMessage").value.replace(/[^a-zA-Z0-9.,!?& ]/gm, '');
    }, false);

    //save gift
    document.querySelector("#giftModalSave").addEventListener("click", function () {
        if (!validateText(document.querySelector("#giftMessage"), "What is the message?")) {
            return;
        }

        localStorage.gift = document.querySelector("#giftMessage").value;
        document.querySelector("#giftModal").close();
        document.querySelector("#cartGiftText").textContent = "Edit";
        document.querySelector("#cartGiftBox").classList.add("active");

    });

    //cancel gift
    document.querySelector("#giftModalCancel").addEventListener("click", function () {
        localStorage.removeItem("gift");
        document.querySelector("#cartGiftText").textContent = "Add a gift message";
        document.querySelector("#cartGiftBox").classList.remove("active");

        document.querySelector("#giftMessage").value = "";
        document.querySelector("#giftMessage").classList.remove("invalid");
        document.querySelector("#giftModal").close();
    });

}

//create even listners - TERMS
let terms = {};
document.querySelector("#cartTerms input").addEventListener("change", function () {
    if (this.checked) {
        document.querySelector("#cartTerms").classList.remove("invalid");
        let currentDate = new Date();
        terms.month = currentDate.getMonth() + 1;
        terms.day = currentDate.getDate();
        terms.year = currentDate.getFullYear().toString().substring(2);
        if (currentDate.getHours() <= 12) {
            terms.hour = currentDate.getHours();
            terms.period = "AM";
        } else {
            terms.hour = currentDate.getHours() - 12;
            terms.period = "PM";
        }
        if (currentDate.getMinutes() < 10) {
            terms.minute = `0${currentDate.getMinutes()}`;
        } else {
            terms.minute = currentDate.getMinutes();
        }
    }
});

/*********************
 Checkout
 *********************/

//last but not least in the cart section, cart button!
document.querySelector("#cartCheckout").addEventListener("click", async function () {
    // check if terms are not checked
    if (cartSettings.enable_terms === true && !document.querySelector("#cartTerms input").checked) {
        alert("Please agree with the terms and conditions.");
        document.querySelector("#cartTerms").classList.add("invalid");
        return
    }

    // start loading
    this.classList.add("loading");

    // check for free product
    if (cartSettings.cart_free_product && cart.total_price >= cartSettings.free_product_threshold) {
        await addProduct({
            id: freeProductVariantID,
            quantity: 1,
            properties: {
                _gift: true
            }
        });
    }

    // update note if terms are enabled
    if (cartSettings.enable_terms === true) {
        // default note
        let formData = {
            note: `Agreed to terms on: ${terms.month}/${terms.day}/${terms.year} - ${terms.hour}:${terms.minute}${terms.period}`
        }

        // check if gift is checked
        formData.attributes = {
            Message: localStorage.gift ?? null
        }

        // update cart
        await updateCart(formData);
    }

    // stop loading
    this.classList.remove("loading");

    // redirect to checkout
    window.location.href = "/checkout";
});

// exchange policy
document.querySelector("#cartTerms a")?.addEventListener("click", function (e) {
    e.preventDefault();

    // open modal
    document.querySelector("#exchangeModal").open();

});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}